export class DiscoveryStatusResponse {
    'lastJob';
    'lastCompletedJob';
    'finished';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "lastJob",
            "baseName": "lastJob",
            "type": "DiscoveryJob",
            "format": ""
        },
        {
            "name": "lastCompletedJob",
            "baseName": "lastCompletedJob",
            "type": "DiscoveryJob",
            "format": ""
        },
        {
            "name": "finished",
            "baseName": "finished",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DiscoveryStatusResponse.attributeTypeMap;
    }
    constructor() {
    }
}
